import api from "../../../api/axios";

const PERFIL_TRILHOS_BASE = "/bases_estaleiro/perfil_trilhos";

export async function listarPerfisTrilhoEstaleiro({ q = "", ativo, limit = 100, offset = 0 } = {}) {
  const { data } = await api.get(`${PERFIL_TRILHOS_BASE}/listar`, {
    params: { q, ativo, limit, offset },
  });
  return Array.isArray(data?.data) ? data.data : [];
}

export async function cadastrarPerfilTrilhoEstaleiro(perfilTrilho) {
  const { data } = await api.post(`${PERFIL_TRILHOS_BASE}/cadastrar`, {
    perfil_trilho: perfilTrilho,
    ativo: 1,
  });
  return data?.data || null;
}

export async function editarPerfilTrilhoEstaleiro(id, perfilTrilho) {
  const { data } = await api.put(`${PERFIL_TRILHOS_BASE}/editar/${id}`, {
    perfil_trilho: perfilTrilho,
  });
  return data?.data || null;
}

export async function alterarStatusPerfilTrilhoEstaleiro(id, ativo) {
  const { data } = await api.patch(`${PERFIL_TRILHOS_BASE}/alterar-ativo/${id}`, {
    ativo: Number(ativo) ? 1 : 0,
  });
  return data?.data || null;
}

export async function excluirPerfilTrilhoEstaleiro(id) {
  const { data } = await api.delete(`${PERFIL_TRILHOS_BASE}/excluir/${id}`);
  return data?.data || null;
}
